<template>
  <div></div>
</template>

<script>

export default {
  name: "Login",
  mounted() {
    const token = this.$route.query.token;
    const expires = this.$route.query.expires;
    const refreshToken = this.$route.query.refreshToken;
    if (token && expires) {
      this.$cookies.set('token', token, Number.parseInt(expires), '/', window.g.domain)
      this.$cookies.set('refreshToken', refreshToken, 60 * 60 * 15, '/', window.g.domain)
    } else if (token) {
      // 30天
      this.$cookies.set('token', token, 60 * 60 * 30, '/', window.g.domain)
      this.$cookies.set('refreshToken', refreshToken, 60 * 60 * 30, '/', window.g.domain)
    }
    this.$router.replace('/')
  }
}
</script>

<style scoped>

</style>
